<template>
  <mb-modal
    :confirmBtnText="confirmBtnText"
    @confirm="handleConfirm"
    title="提示"
    @update:show="close"
    :show="show"
  >
    <p slot="header">提示</p>
    <div slot="content" class="red-text">
      <p v-if="isLoadQuesError">
        由于网络问题，加载题目超时。<br/>
        请确认网络正常后点击“重新加载”再次尝试。
      </p>
      <p v-else>
        由于网络问题，保存超时。<br/>
        请确认网络正常后点击“取消”尝试再次保存。
      </p>
      <div slot="footer" class="mb-footer-text">
        <p class="title">建议：</p>
        <p class="text">
          1、切换为手机4G热点上网；<br/>
          2、切换到其他较快的网络。<br/>
        </p>
      </div>
    </div>
  </mb-modal>
</template>

<script>
import MbModal from '@/components/MbModal'
export default {
  components: {
    MbModal
  },
  props: {
    type: String,
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLoadQuesError() {
      return this.type === 'loadQues'
    },
    confirmBtnText() {
      return this.isLoadQuesError ? '重新加载' : '取消'
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
    handleConfirm() {
      if (this.isLoadQuesError) {
        window.location.reload()
      } else {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .red-text {
    color: #F5222D;
  }
  .mb-footer-text {
    margin-top: 0.8rem;
    font-size: 0.8rem;
    color: #666;
    line-height: 1.6;
    text-align: center;
    .title {
      color: #333;
      text-align: left;
      font-weight: 500;
    }
    .text {
      text-align: left;
    }
  }

  @media only screen and (min-width: 48rem) and (max-width: 80rem) {
    .mb-footer-text {
      margin-top: 0.5rem;
      font-size: 0.53rem;
    }
  }
</style>
